export const dummyChannels = () => {
  return new Array(24).fill().map((_, index) => ({
    id: index.toString(),
    topics: index % 2 === 0 ? [`Lorem Ipsum...`] : [`Lorem Picsum...`]
  }))
}
